module.exports = __webpack_public_path__ + "static/img/2.d8faff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/pharmacy/1/2.png
// module id = tr7I
// module chunks = 1